import ElementPlus from 'element-plus';
// import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/index.css'
import { createApp } from 'vue';
import App from './App.vue';
import Status from './constants/Status';
import router from './router';
import store from './store';
import permission from './directives/permission';
// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App);
app.config.globalProperties.$filters = {
  dateFormat(originVal:Date): string {
    const dt = new Date(originVal);
    const y = dt.getFullYear();
    const m = (`${dt.getMonth() + 1}`).padStart(2, '0');
    const d = (`${dt.getDate()}`).padStart(2, '0');

    const hh = (`${dt.getHours()}`).padStart(2, '0');
    const mm = (`${dt.getMinutes()}`).padStart(2, '0');
    const ss = (`${dt.getSeconds()}`).padStart(2, '0');
    // yyyy-mm-dd hh:mm:ss
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
  },
  statusFormat(value: number): string {
    return Status[value];
  },
};
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(permission);
app.mount('#app');
